import { configureStore } from "@reduxjs/toolkit";
import axios from "axios";
import account from "reducers/account";
import alerts from "reducers/alerts";
import auth from "reducers/auth";
import organization from "reducers/organization";
import portal from "reducers/portal";
import { combineReducers } from "redux";
import axiosMiddleware from "redux-axios-middleware";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import {
  apiService,
  mainUrl,
  rubyApiBaseUrl,
} from "services/rtkApi/apiService";
import { getToken } from "services/token-provider";
import lookupReducer from "../reducers/lookups";
import { LocalStorageKeys } from "../types/enums";
import { rtkQueryErrorLogger } from "./middleware/logger";

//update this to be devUrl, betaUrl, prodUrl or demoUrl depending on backend environment

export const apiUrl = `${mainUrl}api`;

export const rubyApiUrl = `${rubyApiBaseUrl}api`;

export const client = axios.create({
  baseURL: apiUrl,
  responseType: "json",
});

client.interceptors.request.use(async (config) => {
  const token = await getToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  const orgUserId = localStorage.getItem(LocalStorageKeys.OrganizationUserId);
  if (orgUserId) {
    config.headers["X-Org-User-Id"] = orgUserId;
  }

  // Only set Content-Type for non-FormData requests
  // FormData needs to set its own Content-Type with boundary
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});
// Axios response interceptor to handle 401 errors

const persistConfig = {
  key: "lookups",
  storage,
};

const orgPersistConfig = {
  key: "organization",
  storage,
};

const lookupPersistedReducer = persistReducer(persistConfig, lookupReducer);
const orgPersistedReducer = persistReducer(orgPersistConfig, organization);
const rootReducer = combineReducers({
  auth,
  account,
  alerts,
  organization: orgPersistedReducer,
  portal,
  lookups: lookupPersistedReducer,
  [apiService.reducerPath]: apiService.reducer,
});
export const appStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({ serializableCheck: false })
      .concat(thunk, axiosMiddleware(client))
      .concat(apiService.middleware)
      .concat(rtkQueryErrorLogger);
  },
  devTools: process.env.NODE_ENV !== "production",
});
export type AppStore = typeof appStore;
export const persistor = persistStore(appStore);
//export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof appStore.dispatch;
